import styled from 'styled-components';
import OrderDetailTotalPrice from './OrderDetailTotalPrice';
import { gridSizes, textSizes, weights } from 'utils/style';

export default styled(OrderDetailTotalPrice)`
  display: flex;
  width: 100%;
  padding-top: ${gridSizes('M')};
  align-items: baseline;

  .price-literal {
    font-size: ${textSizes('XXL')};
    color: var(--grey900);
    font-weight: ${weights('medium')};
    margin: 0;
    white-space: nowrap;
  }

  .vat-literal {
    flex: 1;
    white-space: nowrap;
    margin-right: ${gridSizes('M')};
    font-weight: ${weights('medium')};
  }
`;
